/**
 * MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationRequired,
} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import Motorista from '@/model/resource/Motorista'
import MotoristaCancelamentoCargaSchema from '@/schema/MotoristaCancelamentoCarga.schema'

export default class MotoristaCancelamentoCarga extends Resource {
  readonly $name: string = 'MotoristaCancelamentoCarga'

  readonly $endpoint: string = '/user/motorista-cancelamento-carga{/id}'

  get $schema() {
    return MotoristaCancelamentoCargaSchema(this)
  }

  get $id() {
    return this.idCancelamentoPk
  }
  set $id(val: ID) {
    this.idCancelamentoPk = val
  }

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  idCancelamentoPk: ID = 0

  @ValidationRequired()
  data: string = ''

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(idMotoristaFk: ID) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = idMotoristaFk
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = idCargaFk
  }
}
